<template>
  <div class="failure-screen">
    <img 
      src="https://img.icons8.com/?size=100&id=11997&format=png&color=000000" 
      alt="Erro" 
      class="failure-icon"
    />
    <p>Erro ao enviar os dados. Por favor, tente novamente.</p>
    <button @click="voltarPaginaInicial" class="btn-voltar">
      Voltar para a página inicial
    </button>
  </div>
</template>

<script>
export default {
  name: 'TelaFalha',
  methods: {
    voltarPaginaInicial() {
      this.$router.push('/'); // Redireciona para a página inicial
    }
  }
};
</script>

<style scoped>
.failure-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: rgb(249, 250, 251) !important;
}

.failure-icon {
  width: 80px; /* Ajusta o tamanho do ícone */
  height: 80px;
  margin-bottom: 20px;
}

p {
  margin-top: 20px;
  font-size: 18px;
  color: #333;
  text-align: center;
}

.btn-voltar {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  background-color: #d9534f;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-voltar:hover {
  background-color: #c9302c;
}
</style>
